/* unplugin-vue-components disabled */import { render } from "./QuestionRenderPage.vue?vue&type=template&id=65ceab8a&scoped=true"
import script from "./QuestionRenderPage.vue?vue&type=script&lang=js"
export * from "./QuestionRenderPage.vue?vue&type=script&lang=js"

import "./QuestionRenderPage.vue?vue&type=style&index=0&id=65ceab8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ceab8a"]])

export default __exports__